/**
 * Returns a list of roots following the binyan nif'al.
 *
 * @returns {string[]} Hebrew roots following the binyan nif'al.
 */
export default function() {
	return [
		"אכל",
		"אמר",
		"לקח",
		"נשא",
		"נתן",
		"קרא",
		"שלח",
		"שמע",
		"אהב",
		"אסף",
		"כרת",
		"כתב",
		"מצא",
		"פקד",
		"שמר",
		"שפט",
		"אבד",
		"אמן",
		"גאל",
		"דרש",
		"הרג",
		"חשב",
		"טמא",
		"יתר",
		"לכד",
		"ספר",
		"עזב",
		"קבץ",
		"קבר",
		"רדף",
		"שרף",
		"שאל",
		"שבר",
		"שחת",
		"שכח",
		"שלם",
		"שפך",
		"אסר",
		"בחר",
		"בלע",
		"בקע",
		"ברא",
		"דרך",
		"זרע",
		"חלק",
		"חנן",
		"חרש",
		"טהר",
		"למד",
		"מכר",
		"משל",
		"סגר",
		"סתר",
		"עזר",
		"ערך",
		"פרד",
		"פרש",
		"צפה",
		"קנה",
		"קרע",
		"רחץ",
		"רפא",
		"שבע",
		"שחט",
		"שמר",
		"תפש",
		"תקע",
		"אשם",
		"בגד",
		"בדל",
		"בחן",
		"גזל",
		"גמל",
		"גנב",
		"הרס",
		"זרק",
		"חבא",
		"חבש",
		"חלץ",
		"חצב",
		"חקר",
		"חרב",
		"חתם",
		"טמן",
		"טרף",
		"לקט",
		"מנע",
		"סלח",
		"סמך",
		"ספר",
		"עצר",
		"פגע",
		"פלט",
		"פרד",
		"פרץ",
		"פשט",
		"צפן",
		"קצר",
		"קשר",
		"רעש",
		"רצח",
		"שחק",
		"שטף",
		"אטם",
		"אלם",
		"ארג",
		"בצע",
		"גאל",
		"גדר",
		"גזז",
		"גזר",
		"גלח",
		"גרע",
		"דחה",
		"דקר",
		"חבל",
		"חרש",
		"חכה",
		"חפר",
		"חקק",
		"חרץ",
		"חשק",
		"טבח",
		"טבל",
		"טבע",
		"כבש",
		"כלא",
		"לחץ",
		"מחץ",
		"מסס",
		"משל",
		"נשא",
		"סחר",
		"סלל",
		"סער",
		"סקל",
		"סתם",
		"עטף",
		"עכר",
		"פרע",
		"פרק",
		"רמס",
		"שאב",
		"שאף",
		"שבר",
		"שכר",
		"שלל",
		"שלף",
		"שקל",
		"שקף",
		"שתל",
		"תכן",
		"תמך",
		"תעב",
		"שפכ‎",
		"דרכ‎",
		"ערכ‎",
		"סמכ‎",
		"תמכ‎",
		"נתנ",
		"אמנ",
		"חננ",
		"בחנ",
		"טמנ",
		"צפנ",
		"תכנ",
		"שלמ",
		"אשמ",
		"חתמ",
		"אטמ",
		"אלמ",
		"סתמ",
		"אספ",
		"רדפ",
		"שרפ",
		"טרפ",
		"שטפ",
		"עטפ",
		"שאפ",
		"שלפ",
		"שקפ",
		"קבצ",
		"רחצ",
		"חלצ",
		"פרצ",
		"חרצ",
		"לחצ",
		"מחצ",
	];
}
